import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from "src/app/services/server.service";

@Component({
  selector: "app-action-items",
  templateUrl: "./action-items.component.html",
  styleUrls: ["./action-items.component.scss"],
})
export class ActionItemsComponent implements OnInit {
  authToken = localStorage.getItem("token");
  userInfo = JSON.parse(localStorage.getItem("userInfo"));
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private _serverService: ServerService,
    private dialogRef: MatDialogRef<ActionItemsComponent>
  ) {}
  actionItemsByReviewId: any;
  ngOnInit() {
    this.getActionItems(this.data);
    console.log(this.data);
  }
  getActionItems(review: any) {
    // console.log(review)
    let url =
      "campaign_module/campaign_reviews/" +
      review.id +
      "?campaign_id=" +
      review.campaign_id;
    this._serverService
      .getActionItemsByCampaignReviewId(url, this.authToken)
      .subscribe((data) => {
        this.actionItemsByReviewId = data.action_items;
        // console.log(this.actionItemsByReviewId)
      });
  }
  close() {
    this.dialogRef.close();
  }
}
